import { useState } from "react";
import { X, Plus } from "lucide-react";

// Simple, self-contained tag / chip editor.
// - value: string[]
// - onChange: (string[]) => void
// - placeholder, testid
export default function ChipEditor({ value = [], onChange, placeholder = "Type and press Enter", testid = "chip-editor" }) {
  const [draft, setDraft] = useState("");

  const add = () => {
    const v = draft.trim();
    if (!v) return;
    if (value.includes(v)) { setDraft(""); return; }
    onChange([...value, v]);
    setDraft("");
  };

  const removeAt = (i) => {
    const next = value.slice();
    next.splice(i, 1);
    onChange(next);
  };

  return (
    <div className="rounded-md border border-slate-200 bg-white p-2" data-testid={testid}>
      <div className="flex flex-wrap gap-2">
        {value.map((chip, i) => (
          <span
            key={`${chip}-${i}`}
            className="inline-flex items-center gap-1 bg-slate-100 border border-slate-200 rounded-full px-3 py-1 text-xs font-medium text-[#0A192F]"
            data-testid={`${testid}-chip-${i}`}
          >
            {chip}
            <button
              type="button"
              className="hover:text-red-600"
              onClick={() => removeAt(i)}
              aria-label={`Remove ${chip}`}
              data-testid={`${testid}-remove-${i}`}
            >
              <X className="w-3 h-3" />
            </button>
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2 mt-2">
        <input
          className="flex-1 outline-none text-sm bg-transparent placeholder:text-slate-400 py-1"
          placeholder={placeholder}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); }
            else if (e.key === "Backspace" && !draft && value.length) { removeAt(value.length - 1); }
          }}
          data-testid={`${testid}-input`}
        />
        <button
          type="button"
          onClick={add}
          className="inline-flex items-center gap-1 text-xs font-medium text-[#1E3A8A] hover:text-[#1E40AF] disabled:opacity-40"
          disabled={!draft.trim()}
          data-testid={`${testid}-add-btn`}
        >
          <Plus className="w-3 h-3" /> Add
        </button>
      </div>
    </div>
  );
}
